export const calculateEnergy = (
  lastData: number,
  energyIncreasePerHour: number,
  lastUpdated: Date,
  maxLimit?: number,
): number => {
  const now = new Date();
  const hoursDifference =
    (now.getTime() - new Date(lastUpdated).getTime()) / (1000 * 60 * 60);

  const result = Math.floor(lastData + energyIncreasePerHour * hoursDifference);

  return maxLimit && result > maxLimit ? maxLimit : result;
};
